module.exports = __webpack_public_path__ + "img/495E48_0D100D_9D9C87_9ECC9C-256px.7fdd45cc.png";